export default __webpack_public_path__ + "772af2e9ae4dd428fb91041dee8b548d.png";